import React from 'react'

import './tecnologias.css'

import images from '../../assets'

const Tecnologias = () => {
  return (
    <div className='lsk__tecnologias'>
        <h1>Tecnologias de Ponta <br/>Utilizadas em nossos serviços</h1>
        <ul>
            <li className='flex-item'><img src={ images.angular } alt='angular' className='lsk__tecnologias-images_angular'/></li>
            <li className='flex-item'><img src={ images.nodejs } alt='nodejs' className='lsk__tecnologias-images_nodejs'/></li>
            <li className='flex-item'><img src={ images.amazon } alt='amazon' className='lsk__tecnologias-images_amazon'/></li>
            <li className='flex-item'><img src={ images.java } alt='java' /></li>
            <li className='flex-item'><img src={ images.python } alt='python' /></li>
            <li className='flex-item'><img src={ images.microsoftazure } alt='microsoftazure' /></li>
            <li className='flex-item'><img src={ images.googlecloud } alt='googlecloud' /></li>
            <li className='flex-item'><img src={ images.react } alt='react' /></li>
            <li className='flex-item'><img src={ images.pfsense } alt='pfsense' className='lsk__tecnologias-images_pfsense'/></li>
            <li className='flex-item'><img src={ images.cisco } alt='react' className='lsk__tecnologias-images_cisco' /></li>
            <li className='flex-item'><img src={ images.fortinet } alt='fortinet' className='lsk__tecnologias-images_fortinet' /></li>
            <li className='flex-item'><img src={ images.kaspersky } alt='kasersky'  className='lsk__tecnologias-images_fortinet' /></li>
            <li className='flex-item'><img src={ images.gitlab } alt='gitlab'  className='lsk__tecnologias-images_fortinet' /></li>
        </ul>
      </div>
  )
}

export default Tecnologias